import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryCustomerBrandsByCustomer(customerName: string) {
  const { customerService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(
    ['customer-brands', customerName],
    () => customerService.getCustomerBrandsByCustomer(customerName),
    {
      enabled: !!customerName,
    }
  );

  return { customerBrands: data, isLoading, isFetching } as const;
}
